import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { APP_VERSION } from "@/constants/site";
import { toast } from "@/hooks/use-toast";
import { Layout } from "@/components/Layout";
import Login from "@/pages/Login";
import Cadastro from "@/pages/Cadastro";
import Landing from "@/pages/Landing";
import { Termos, Privacidade } from "@/pages/Legal";
import Hub from "@/pages/Hub";
import ChatPage from "@/pages/Chat";
import Rotina from "@/pages/Rotina";
import Perfil from "@/pages/Perfil";
import Planos from "@/pages/Planos";
import Admin from "@/pages/Admin";
import PagamentoSucesso from "@/pages/PagamentoSucesso";
import CookieConsent from "@/components/CookieConsent";
import { Spark } from "@/components/Spark";
import { Toaster } from "@/components/ui/toaster";

function Loading() {
  return (
    <div className="dark min-h-screen flex items-center justify-center bg-background">
      <Spark className="h-10 w-10" animated />
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

// Raiz: deslogado vê a landing pública; logado cai direto no app (Hub).
function HomeRoute() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Landing />;
  return <Layout><Hub /></Layout>;
}

// Planos é a porta de entrada do funil: deslogado vê a versão pública
// (escolher plano → /cadastro); logado vê dentro do app (upgrade).
function PlanosRoute() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Planos publico />;
  return <Layout><Planos /></Layout>;
}

// Mata o bug do "não abre logado no PC" (cache velho do Cloudflare): compara o
// version.json FRESCO do servidor com a versão presa neste bundle. Diferente =
// o navegador está rodando bundle antigo → avisa (sem forçar reload).
function useVersionCheck() {
  useEffect(() => {
    fetch("/version.json?ts=" + Date.now(), { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data?.version && data.version !== APP_VERSION) {
          toast({
            title: "Nova versão disponível",
            description: "Recarregue a página (Ctrl+F5) pra pegar as novidades.",
            action: (
              <button
                onClick={() => window.location.reload(true)}
                className="rounded-full bg-violet-600 hover:bg-violet-500 text-white text-xs font-medium px-3 py-1.5"
              >
                Recarregar
              </button>
            ),
          });
        }
      })
      .catch(() => {});
  }, []);
}

function App() {
  useVersionCheck();
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomeRoute />} />
            <Route path="/login" element={<Login />} />
            <Route path="/cadastro" element={<Cadastro />} />
            <Route path="/termos" element={<Termos />} />
            <Route path="/privacidade" element={<Privacidade />} />
            <Route path="/chat" element={<Protected><ChatPage /></Protected>} />
            <Route path="/chat/:id" element={<Protected><ChatPage /></Protected>} />
            <Route path="/rotina" element={<Protected><Rotina /></Protected>} />
            <Route path="/perfil" element={<Protected><Perfil /></Protected>} />
            <Route path="/planos" element={<PlanosRoute />} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="/pagamento/sucesso" element={<PagamentoSucesso />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieConsent />
          <Toaster />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
